<script setup lang="ts">
import { ref } from 'vue';

const emit = defineEmits(['close']);

const planilhaRef = ref<any>(null);
const arquivosZipRef = ref<any>(null);

async function preSubmit(_: any)
{
  await planilhaRef.value.upload();
  await arquivosZipRef.value.upload();
  return true;
}
</script>

<template>
  <CompromissoJobCommandForm
    command="ImportarArquivosCommand"
    :show-upload-files="false"
    :pre-submit="preSubmit"
    @close="() => emit('close')"
  >
    <template #form="{ model }">
      <a-alert
        show-icon
        style="margin-bottom: 24px"
      >
        <template #message>
          <a
            target="_blank"
            href="/TEMPLATE_IMPORTACAO_ARQUIVO.xlsx"
          >Clique aqui para baixar o template da planilha de importação</a>
        </template>
      </a-alert>

      <a-collapse>
        <a-collapse-panel
          key="1"
          header="GUIA DE COMO PREENCHER OS CAMPOS DA PLANILHA"
          style="margin-bottom: 24px"
        >
          <div>
            <h4>PASTA_CODIGO - obrigatório</h4>
            <p>
              Código da pasta para onde o arquivo será importado
            </p>
          </div>
          <div>
            <h4>ARQUIVO - obrigatório</h4>
            <p>
              Caminho dentro do ZIP de anexos onde o arquivo se encontra
            </p>
          </div>
          <div>
            <h4>REFERENCIA_GCPJ - opcional</h4>
            <p>Referência GCPJ do documento</p>
          </div>
        </a-collapse-panel>
      </a-collapse>

      <a-form-item
        label="Planilha"
        name="planilha"
        :rules="{
          message: 'Planilha é obrigatória',
          required: true,
          trigger: 'change',
          type: 'object',
        }"
      >
        <UploadFile
          ref="planilhaRef"
          v-model:file="model.planilha"
        />
      </a-form-item>

      <a-form-item
        label="ZIP com arquivos"
        name="arquivosZip"
        :rules="{
          message: 'Zip de Arquivos é obrigatório',
          required: true,
          trigger: 'change',
          type: 'object',
        }"
      >
        <UploadFile
          ref="arquivosZipRef"
          v-model:file="model.arquivosZip"
        />
      </a-form-item>
    </template>
  </CompromissoJobCommandForm>
</template>
